/**
 * MovementEngine: converts InputSamples into therapeutic movement values (deg / cm) using the
 * coordinate mapping published by the backend rules. No gameplay or visuals here.
 */
export class MovementEngine {
  constructor(mapping) { this.m = mapping; }

  displayMax(metric) {
    if (metric === "reach_cm") return this.m.reach_display_max_cm;
    if (metric === "hip_flexion") return this.m.hip_display_max_deg;
    return this.m.angle_display_max_deg;
  }

  amplitudeFromY(metric, y) {
    const v = ((this.m.y_base - y) / this.m.y_span) * this.displayMax(metric);
    return Math.max(0, Math.round(v * 10) / 10);
  }

  yFromAmplitude(metric, v) { return this.m.y_base - (Math.min(v, this.displayMax(metric)) / this.displayMax(metric)) * this.m.y_span; }

  lateralReachFromX(x) { return Math.round((Math.abs(x - 0.5) / this.m.lateral_span) * this.m.reach_display_max_cm * 10) / 10; }

  sideFromX(x) { return x < 0.5 ? "left" : "right"; }

  /** distance in stage-width units (aspect corrected) */
  distance(a, b, aspect) { return Math.hypot(a.x - b.x, (a.y - b.y) * aspect); }

  toMovement(sample, metric) {
    if (sample.amplitude !== undefined) return { side: sample.side, amplitude: sample.amplitude };
    return { side: this.sideFromX(sample.x), amplitude: this.amplitudeFromY(metric, sample.y) };
  }
}

export const DEFAULT_MAPPING = {
  y_base: 0.88, y_span: 0.6, angle_display_max_deg: 150, reach_display_max_cm: 40, hip_display_max_deg: 90, lateral_span: 0.45,
};
